
import ViewerItem from '../../components/viewer/item';
import {mapGetters} from "vuex";
import { http } from '@/libs/util.js'
import { util_api } from '@/libs/util_api';
const { bank_statement_match_rule } = util_api
const keys = ['expense_groups', 'income_bills', 'bank_statement_items']
const item_flag_hash = {
  bank: '银行',
  alipay: '支付宝',
  wechat: '微信'
}
export function displayBills(item) {
  const income_bills = Object.keys(item.income_bills).reduce((tocal, key) => tocal.concat(item.income_bills[key]), [])
  item = {
    ...item,
    income_bills,
    bank_statement_items: item.bank_statement_items.map(item => ({
      uid:item.settle_no 
    }))
  }
  
  return keys.reduce((total, key) => {
    if (total.length) {
      return total
    }
    return item[key] || []
  }, [])
}

// bank_statement_match_rule
export default {
  components: { ViewerItem },
  data() {
    return {
      loading_hash: {

      },
      // 自动单据配置 两个页面相关
      bank_statement_item_columns: [
        {
          title: '公司',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const company = this.companies_hash[row.company_id];
            return h('span', company ? company.short_name : '-');
          }
        },
        {
          title: '银行账号',
          key: 'bank_number',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '交易时间',
          key: 'transaction_time',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatTime(row.transaction_time));
          }
        },
        {
          title: '回单',
          align: 'center',
          width: 50,
          render: (h, params) => {
            const row = params.row;
            const receipt = row.receipt;
            if (receipt) {
              return h('a', {
                attrs: {
                  href: this.$util.receiptUrl(receipt.filename),
                  target: '_blank'
                },
                class: {
                  link: true
                }
              }, '查看')
            }
            return h('span', '-');
          }
        },
      {
          title: '关联单据/流水',
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const linked_arr = displayBills(row)
            if (linked_arr.length) {
              const content = linked_arr.map(eg => h('p', {
                style: {
                  margin: 0
                }
              }, eg.uid))
              return h(ViewerItem, {
                props: {
                  model_id: row.id,
                  type: 'BankStatementRelations',
                  tip: false
                },
                class: {
                  link: true
                }
              }, content);
            }
            return h('span', '-');
          }
        },
        {
          title: '自动单据规则',
          align: 'center',
          width: 90,
          render: (h, params) => {
            const row = params.row;
            const is_credit = row.debit_credit_flag === 'credit' && row.income_rule_id
            const is_debit = row.debit_credit_flag === 'debit' && row.expense_rule_id
            if (is_credit || is_debit) {
              return h('span', {
                class: {
                  'color-grey': true
                }
              }, '已匹配')
            }
            return h('span', '-');
          }
        },
        {
          title: '借方金额',
          align: 'right',
          minWidth: 110,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.debit_amount));
          }
        },
        {
          title: '贷方金额',
          align: 'right',
          minWidth: 110,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.credit_amount));
          }
        },
        {
          title: '余额',
          align: 'right',
          minWidth: 110,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.balance_amount));
          }
        },
        {
          title: '交易类型',
          key: 'transaction_type',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.transaction_type || '-');
          }
        },
        {
          title: '交易代码',
          key: 'trscod',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.trscod || '-');
          }
        },
        {
          title: '交易代码解释',
          align: 'center',
          minWidth: 90,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.trscod_desc || '-');
          }
        },
        {
          title: '摘要',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.remark || '-');
          }
        },
        {
          title: '业务摘要',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.business_remark || '-');
          }
        },
        {
          title: '其他摘要',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.other_remark || '-');
          }
        },
        {
          title: '流水号',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.settle_no || '-');
          }
        },
        {
          title: '对方户名',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.opposite_account_name || '-');
          }
        },
        {
          title: '对方账号',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.opposite_bank_number || '-');
          }
        },
        {
          title: '对方开户行',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.opposite_bank_name || '-');
          }
        },
      ],
      bank_statement_item_columns_thrid: [
        {
          title: '公司',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const company = this.companies_hash[row.company_id];
            return h('span', company ? company.short_name : '-');
          },
          statement_type: [],
        },
        // {
        //   title: '账号', // todo
        //   key: 'bank_number',
        //   align: 'center',
        //   minWidth: 120,
        // },
        {
          title: '商户号', 
          key: 'bank_number',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '交易时间',
          key: 'transaction_time',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatTime(row.transaction_time));
          }
        },
        // {
        //   title: '回单',
        //   align: 'center',
        //   width: 50,
        //   render: (h, params) => {
        //     const row = params.row;
        //     const receipt = row.receipt;
        //     if (receipt) {
        //       return h('a', {
        //         attrs: {
        //           href: this.$util.receiptUrl(receipt.filename),
        //           target: '_blank'
        //         },
        //         class: {
        //           link: true
        //         }
        //       }, '查看')
        //     }
        //     return h('span', '-');
        //   }
        // },
        {
          title: '业务流水号', 
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('span', row.settle_no || '-');
          }
        },
        {
          title: '财务流水号', 
          minWidth: 160,
          align: 'center',
          key: 'other_remark',
        },
      {
          title: '关联单据/流水', 
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const linked_arr = displayBills(row)
            if (linked_arr.length) {
              const content = linked_arr.map(eg => h('p', {
                style: {
                  margin: 0
                }
              }, eg.uid))
              return h(ViewerItem, {
                props: {
                  model_id: row.id,
                  type: 'BankStatementRelations',
                  tip: false
                },
                class: {
                  link: true
                }
              }, content);
            }
            return h('span', '-');
          }
        },
        {
          title: '业务类型', 
          minWidth: 160,
          align: 'center',
          key: 'transaction_type',
        },
        {
          title: '交易渠道',
          minWidth: 160,
          align: 'center',
          // item_flag_hash
          render: (h, params) => {
            const row = params.row;
            return h('span', item_flag_hash[row.item_flag] || '-');
          }
        },
        {
          title: '收入金额',
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.credit_amount));
          }
        },
        {
          title: '支出金额',
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.debit_amount));
          }
        },
        {
          title: '账户余额',
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('span', this.$util.formatPrice(row.balance_amount));
          }
        },
        {
          title: '备注',
          minWidth: 160,
          key: 'remark',
          align: 'center',
        },
      ],
      bills_item_columns: [
        {
          title: '公司',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const company = this.companies_hash[row.company_id];
            return h('span', company ? company.short_name : '-');
          }
        },
        {
          title: '团队',
          align: 'center',
          minWidth: 80,
          // teams_hash
          render: (h, params) => {
            const row = params.row;
            const team = this.teams_hash[row.team_id];
            return h('span', team ? team.name : '-');
          }
        },
        {
          title: '申请人',
          align: 'center',
          minWidth: 80,
          key: 'apply_user'
        },
        {
          title: '是否已关联单据',
          align: 'center',
          minWidth: 80,
          render(h, { row }) {
          return <span>{row.bank_statement_items && row.bank_statement_items.length > 0 ? '是' : '否'}</span>
          }
        },
        {
          title: '单据名称',
          key: 'name',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '单据编号',
          key: 'uid',
          align: 'center',
          minWidth: 80,
        },
        {
          // total_price
          title: '付款金额',
          key: 'total_price',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const total_price = row.total_price
            return h('span', this.$util.formatPrice(total_price));
          }
        },
        // 付款账户
        {
          title: '付款账户',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_account'
        },
        // 付款银行
        {
          title: '付款银行',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_name',
          render(h, {row}) {
            return <span>
              {
                (row.payment_bank_name || '') + '-' + (row.payment_bank_number || '')
              }
            </span>
          }
        },
        // 付款账号
        {
          title: '付款账号',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_number'
        },
        // 付款时间
        {
          title: '付款时间',
          align: 'center',
          minWidth: 80,
          key: 'paid_at'
        },
        // 收款方账户名
        {
          title: '收款方账户名',
          align: 'center',
          minWidth: 80,
          key: 'payee_account_name'
        },
        // 收款方开户行
        {
          title: '收款方开户行',
          align: 'center',
          minWidth: 80,
          key: 'payee_bank'
        },
        {
          title: '收款方账号',
          align: 'center',
          minWidth: 80,
          key: 'payee_bank_number'
        },
        // 入账时间
        {
          title: '入账时间',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            return h('span', row.verified_at ? this.$util.formatTime(row.verified_at) : '-');
          }
        },
      ],
      bills_item_columns_receipt: [
        {
          title: '公司',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const company = this.companies_hash[row.company_id];
            return h('span', company ? company.short_name : '-');
          }
        },
        {
          title: '是否已关联单据',
          align: 'center',
          minWidth: 80,
          render(h, { row }) {
          return <span>{row.bank_statement_items && row.bank_statement_items.length > 0 ? '是' : '否'}</span>
          }
        },
        {
          title: '单据名称',
          key: 'name',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '单据编号',
          key: 'uid',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '收款金额',
          key: 'total_amount',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            const row = params.row;
            const total_amount = row.total_amount
            return h('span', this.$util.formatPrice(total_amount));
          }
        },
        // 付款账户
        {
          title: '收款账户',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_account',
          render(h, {row}) {
            const receipt_bank = row.receipt_bank || {}
            return <span>{receipt_bank.account}</span>
          }
        },
        // 付款银行
        {
          title: '收款银行',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_name',
          render(h, {row}) {
            const receipt_bank = row.receipt_bank || {}
            return <span>
              {
                (receipt_bank.bank || '')
              }
            </span>
          }
        },
        // 付款账号
        {
          title: '收款账号',
          align: 'center',
          minWidth: 80,
          key: 'payment_bank_number',
          render(h, {row}) {
            const receipt_bank = row.receipt_bank || {}
            return <span>
              {
                 (receipt_bank.bank_number || '')
              }
            </span>
          }
        },
        // 付款时间
        {
          title: '入账时间',
          align: 'center',
          minWidth: 80,
          key: 'handled_at'
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      companies: 'async/companies',
      companies_hash: 'async/companies_hash',
      teams_hash: 'async/root_teams_hash'
    }),
    action_colunm() {
      return {
        title: '操作',
        align: 'center',
        fixed: 'right',
        minWidth: 100,
        render: (h, params) => {
          const row = params.row;
          const is_credit = row.debit_credit_flag === 'credit' && row.income_rule_id // && (row.income_bills || []).length
          const is_debit = row.debit_credit_flag === 'debit' && row.expense_rule_id // && (row.expense_groups || []).length
          let linked_expenses = row.expense_groups || [];
          if (row.debit_credit_flag === 'credit') {
            linked_expenses = Object.values(row.income_bills || {}).flat()
          }
          if (!is_credit && !is_debit && !linked_expenses.length) {
            return h('Button', {
             props: {
              type: 'primary',
              size: 'small',
              loading: this.loading_hash[row.id]
             },
             on: {
               click:() => {
                 this.$set(this.loading_hash, row.id, true)
               // this.loading_hash[row.id] = true
                 http.post(bank_statement_match_rule, {id:row.id}).then((res) => {
                   if (this.statementHttpCallback) {
                    this.statementHttpCallback(res)
                   }
                  this.$Message.success({
                    content: '匹配成功'
                  })
                 }).finally(() => {
                  this.loading_hash[row.id] = false
                 })
               }
             }
            }, '匹配')
          }
          return h('span', '-');
        }
      }
    },
  }
}
